import { render, staticRenderFns } from "./DeviceAssignmentRole.vue?vue&type=template&id=59b1e4f2&scoped=true&"
import script from "./DeviceAssignmentRole.vue?vue&type=script&lang=ts&"
export * from "./DeviceAssignmentRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b1e4f2",
  null
  
)

export default component.exports